export function formatPriceCop(value) {
  if (value == null || Number.isNaN(Number(value))) return null;
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  }).format(Number(value));
}

export function formatMileageKm(value) {
  if (value == null || Number.isNaN(Number(value))) return null;
  return `${new Intl.NumberFormat("es-CO").format(Number(value))} km`;
}

export function formatPriceRange(min, max) {
  const low = formatPriceCop(min);
  const high = formatPriceCop(max);
  if (low && high) {
    if (min === max) return low;
    return `${low}–${high}`;
  }
  return low || high || null;
}

export function formatAggregateSummary(aggregates = {}) {
  const parts = [];
  const priceRange = formatPriceRange(aggregates.priceMin, aggregates.priceMax);
  if (priceRange) parts.push(priceRange);
  const mileage = formatMileageKm(aggregates.mileageAvg);
  if (mileage) parts.push(`Avg ${mileage}`);
  if (aggregates.needsReviewCount > 0) {
    parts.push(`${aggregates.needsReviewCount} need review`);
  }
  return parts.join(" · ");
}

export function mapFlatStatusToGroupedStatus(flatStatus) {
  if (!flatStatus) return "all";
  if (flatStatus === "active") return "available";
  if (flatStatus === "sold") return "sold";
  return null;
}

export function isGroupedStatusSupported(flatStatus) {
  return !flatStatus || flatStatus === "active" || flatStatus === "sold";
}
